import { BasicPermissionItem } from '../../PermissionItem'
import {
  EditPackageNumberName,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
  CreateViewEditSoftRemoveRestore,
} from '../../common'
import { CASTracker } from '../../../cimsPage/instances/cas'
import { CASStatus } from '../../../statuses/cas'

const object = 'Construction & Admin Submittal'
const page = CASTracker

const submittal = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '755ce5b9-9e9f-4a18-ae79-82f0b55deb63',
  view: '60d0029d-01d8-4391-a145-7ee184383d87',
  edit: 'c4e3f334-7796-48ee-bbd8-4e9bb9290c88',
  removeRestore: '60cb0e80-a7fe-4bf3-97cb-5d93b4e1df07',
})

export const CreateConstructionAdminSubmittal = submittal.Create
export const ViewConstructionAdminSubmittal = submittal.View
export const EditConstructionAdminSubmittal = submittal.Edit
export const RemoveRestoreConstructionAdminSubmittal = submittal.RemoveRestore

export const ReviseConstructionAdminSubmittal = Simple({
  id: '104b9e36-f2e4-482a-839b-0d069a0513d1',
  action: 'Revise',
  page,
  object,
})

export const RouteConstructionAdminSubmittal = Simple({
  id: '3dbcafb5-2c8a-4952-a2fe-1b3d11f3ebc0',
  action: 'Route',
  page,
  object,
})

export const GroupReviewConstructionAdminSubmittal = new BasicPermissionItem({
  id: '260fe314-d5e7-4d8e-9309-c7ec522de188',
  name: `Advance ${CASStatus.GroupReview.name} ${object}s`,
  action: `take action when all boxes have been checked during ${CASStatus.GroupReview.name}`,
  page,
  allowMixedCase: true,
})

export const GiveDispositionConstructionAdminSubmittal = GiveDisposition({
  id: 'a983ac16-1713-4cfd-8a57-6ba792f74ea1',
  page,
  object,
})

export const CommentOnConstructionAdminSubmittal = Simple({
  id: '7428deca-ed63-44d5-bcc1-f6388b93c1a5',
  action: 'Comment on',
  page,
  object,
})

export const EditNumberNameConstructionAdminSubmittal = EditPackageNumberName({
  id: '08830a66-8cef-4e04-91ef-52910df2097d',
  page,
  object,
})

export const RevertConstructionAdminSubmittal = Revert({
  id: 'f0ac31d8-97d1-4336-bbfe-2591c4c64007',
  page,
  object,
})

export const ReviewAllConstructionAdminSubmittal = new BasicPermissionItem({
  id: '905fe4ac-8285-43a5-a320-0f78f8594a83',
  name: `${CASStatus.GroupReview.name} All ${object}s`,
  action: `check all boxes during ${CASStatus.GroupReview.name}`,
  page,
  allowMixedCase: true,
})

export const UnlockConstructionAdminSubmittal = Unlock({
  id: '2406919e-3bcb-4e8c-8c26-ab13e432d8fe',
  page,
  object,
})

/** Does not necessarily give you access to PDF Reports */
export const CreateCASPacket = Simple({
  id: '1bd8fe12-7397-49ae-904b-1fc6a1ad73ae',
  action: 'Create',
  object: `${object} Packet`,
  page,
})

export type CASTrackerPermission =
  | typeof CreateConstructionAdminSubmittal
  | typeof ViewConstructionAdminSubmittal
  | typeof EditConstructionAdminSubmittal
  | typeof RemoveRestoreConstructionAdminSubmittal
  | typeof ReviseConstructionAdminSubmittal
  | typeof RouteConstructionAdminSubmittal
  | typeof GroupReviewConstructionAdminSubmittal
  | typeof GiveDispositionConstructionAdminSubmittal
  | typeof CommentOnConstructionAdminSubmittal
  | typeof EditNumberNameConstructionAdminSubmittal
  | typeof RevertConstructionAdminSubmittal
  | typeof ReviewAllConstructionAdminSubmittal
  | typeof UnlockConstructionAdminSubmittal
  | typeof CreateCASPacket
